<template>
    <edit-selection
        ref="input"
        v-model="inputValue"
        form
        :disabled="disabled"
        :required="required"
        :rules="rulesValue"
        :error-messages="errorMessagesValue"
        :label="labelValue || $t('user_status')"
        :items="items"
        :autocomplete="false"
    />
</template>

<script>
import BaseField from './BaseField';
import userStatusEnum from '@/enums/user/status';

export default {
    name: 'UserStatus',
    extends: BaseField,
    props: {
        exclude: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        items() {
            return Object.keys(userStatusEnum)
                .filter(k => !this.exclude.includes(k))
                .map(k => ({
                    text: this.$t('enums.user_status.' + k),
                    value: k
                }));
        }
    }
};
</script>
